import React, { useContext } from 'react'
import './HackathonType.css'
import { MainContext } from '../ContextStore/MainContext'

export default function HackathonType() {
    const { hackathonType, setHackathonType } = useContext(MainContext)
    return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <div className='hackathonTypeComponent'>
                <p className='hackathonType' onClick={() => setHackathonType("current")}
                    style={{
                        backgroundColor: hackathonType === "current" ? "var(--mainColor)" : "rgba(11, 81, 78, 0.01)",
                        color: hackathonType === "current" ? "white" : "black"
                    }}
                >Current</p>
                <p className='hackathonType' onClick={() =>{ setHackathonType("pastHackathons");console.log("hi");}}
                    style={{
                        backgroundColor: hackathonType === "pastHackathons" ? "var(--mainColor)" : "rgba(11, 81, 78, 0.01)",
                        color: hackathonType === "pastHackathons" ? "white" : "black"
                    }}
                >Past Hackathons</p>
            </div>
        </div>
    )
}
